import React from 'react';
import Partnership from '../containers/Partnerships/Partnerships'
import Footer from '../containers/Footer/Footer';
  
const Partnerships = () => {
  return (
    <div>
      <Partnership />
      <Footer />
    </div>
  );
};
  
export default Partnerships;